import {getQueryString, isCatalogPath, isIframer} from 'src/utils/url';

class ShopByNav {
  constructor() {
    this.toggleSubCatLinks = this.toggleSubCatLinks.bind(this);
    $(document).on('click', '.pc-ShopByNav-catHeader', this.toggleSubCatLinks);
  }

  // Private

  toCatHeader(e) {
    const catHeader = $(e.target);
    if (catHeader.is('.pc-ShopByNav-catHeader')) {
      return catHeader;
    }
    return catHeader.closest('.pc-ShopByNav-catHeader');
  }

  catHeader(catId) {
    return $(`.pc-ShopByNav-catHeader[data-id="${catId}"]`);
  }

  toggleSubCatLinks(e) {
    if ($(e.target).is('.pc-ShopByNav-catHeaderLink')) {
      e.preventDefault();
    }
    const header = this.toCatHeader(e);
    const catId = header.data('id');
    if (header.data('fetched') === 0) {
      this.fetchSubCatLinks(catId);
    } else {
      this.toggleSubCatSection(catId);
    }
  }

  fetchSubCatLinks(catId) {
    const header = this.catHeader(catId);
    const slug = header.data('slug');
    const queryString = getQueryString();
    const catLinkSelector = '.pc-ShopByNav-catHeaderLink:only-child';
    const catLink = header.find(catLinkSelector).attr('href');
    const catPath = catLink.match(/\/products.*\/([^\/]+\/[0-9]+)(?=[?#]|$)/);
    let subCatUri = `/products/categories/${slug}/${catId}.json`;

    if (catPath && catPath[1] && catPath[1] !== '${slug}/${catId}') {
      subCatUri = `/products/categories/${catPath[1]}.json`;
    } else if (catLink) {
      ProductCatalog.ShopByNav.addViewAllLink(catId, header, catLink);
      ProductCatalog.ShopByNav.toggleSubCatSection(catId);
      return true;
    }
    if (queryString !== '') {
      subCatUri = `${subCatUri}${queryString}`;
    }

    return $.ajax({
      type: 'GET',
      contentType: 'application/json',
      url: subCatUri
    }).done(function (response, textStatus, jqXHR) {
      if (jqXHR.status === 200) {
        header.data('fetched', 1);
        ProductCatalog.ShopByNav.addSubCatLinks(catId, header, response);
        ProductCatalog.ShopByNav.toggleSubCatSection(catId);
      }
    });
  }

  addViewAllLink(catId, header, catLink) {
    const linkClass = 'pc-ShopByNav-catSubLink';
    const viewAllLink = `<a class="${linkClass}" href="${catLink}">View All</a>`;

    header.next('.pc-ShopByNav-catSubLinks').remove();
    header.after(`<div class="pc-ShopByNav-catSubLinks">${viewAllLink}</div>`);
  }

  addSubCatLinks(catId, header, subCatsList) {
    const subCatsListHtml = subCatsList.map(function (subCat) {
      const targetUrl = isIframer() && !isCatalogPath(subCat.link) ? 'target="_blank"' : '';
      return `<a
          class="pc-ShopByNav-catSubLink" ${targetUrl} href="${subCat.link}">${subCat.name}</a>`;
    });

    header.next('.pc-ShopByNav-catSubLinks').remove();
    header.after(
      `<div class="pc-ShopByNav-catSubLinks">${subCatsListHtml.join('')}</div>`
    );
  }

  toggleSubCatSection(catId) {
    const header = this.catHeader(catId);
    const value = header.hasClass('expanded') ? 'collapse' : 'expanded';
    header.next('.pc-ShopByNav-catSubLinks').slideToggle(300);
    header.toggleClass('expanded');
    const name = header.text().trim().toLowerCase();
    return CustomInk.Metrics.fireEvent('ShopByNav Category', name, value);
  }
}

jQuery(() => (ProductCatalog.ShopByNav = new ShopByNav()));
